import spliceIcon from '../../icons/close_icon.svg';
import ape_about from '../../icons//ape_mobile_about.svg';
import banner from '../../images/banner.jpg';
import {
  Container,
  SpanTitle,
  TextOne,
  TextTwo,
  Title,
  WrapContent,
} from './About.styled';

export const About = () => {
  return (
    <Container>
      <WrapContent>
        <Title>
          A STORY THAT STARTED WITH <SpanTitle>ONE SIMPLE APE</SpanTitle>
        </Title>
        <TextOne>
          WHO GOT FED UP WITH BORING AND HYPOCRITIC COMMONPLACE THIS IS HOW THE
          IDEA OF ESCAPING AND DYNAMIC JOURNEY ON THE YACHT
        </TextOne>
        <img src={spliceIcon} alt="splice Icon" />
        <TextTwo>
          EACH ARTWORK IN THE COLLECTION TELLS A STORY OF ONE JOURNEY. ARTS ARE
          RANDOMLY GENERATED BY USERS
        </TextTwo>
        <img src={ape_about} alt="ape" />
      </WrapContent>
      <img src={banner} alt="banner" />
    </Container>
  );
};
